import { useCreateMutation } from '../../graphql';
import { Group } from '../domain';
import { useCurrentWorkspace } from '../../auth';

const CREATE_GROUP = `
  mutation createGroup($input: CreateGroupInput!) {
    createGroup(input: $input) {
      id
      name
    }
  }
`;

export const useCreateGroup = () => {
  const workspace = useCurrentWorkspace();
  const { mutateAsync } = useCreateMutation({
    modelName: 'group',
    query: CREATE_GROUP,
  });

  const createGroup = async (name: string): Promise<Group> => {
    if (!workspace) {
      throw new Error('No workspace available');
    }

    const input = {
      name,
      workspace: { id: workspace.id },
    };

    const result = await mutateAsync({ input });
    return result;
  };

  return { createGroup };
};
